// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { InputTokens } from './type';

const inputTokens: InputTokens = {
  inputFontSize: 'Font-14',
  inputFontColor: 'Neutral-text-5',
  inputFontWeight: 'Weight-regular',
  inputBorderRadius: 'Radius-default',
  inputBorderColor: 'Neutral-border-2',
  inputBorderWidth: 'Border-1',
  inputPaddingX: 'Spacing-8',
  inputPaddingY: 'Spacing-4',
  inputIconSize: 'Font-14',
  inputIconColor: 'Neutral-text-4',
  inputSmallFontSize: 'Font-12',
  inputSmallPaddingX: 'Spacing-8',
  inputSmallPaddingY: 'Spacing-1',
  inputSmallIconSize: 'Font-12',
  inputLargeFontSize: 'Font-16',
  inputLargePaddingX: 'Spacing-12',
  inputLargePaddingY: 'Spacing-7',
  inputLargeIconSize: 'Font-16',
  inputPlaceholderColor: 'Neutral-text-2',
  inputPlaceholderFontWeight: 'Weight-regular',
  inputBackgroundColor: 'Neutral-fill-1',
  inputClearColor: 'Neutral-text-3',
  inputToggleColor: 'Neutral-text-4',
  inputHoverBorderColor: 'Brand-5',
  inputHoverBackgroundColor: 'Neutral-fill-1',
  inputHoverClearColor: 'Neutral-text-4',
  inputHoverToggleColor: 'Neutral-text-5',
  inputHoverIconColor: 'Brand-6',
  inputFocusBorderColor: 'Brand-7',
  inputFocusBackgroundColor: 'Neutral-fill-1',
  inputFocusShadow: 'Brand-2',
  inputDisabledFontColor: 'Neutral-text-2',
  inputDisabledPlaceholderColor: 'Neutral-text-2',
  inputDisabledBorderColor: 'Neutral-border-1',
  inputDisabledBackgroundColor: 'Neutral-fill-2',
  inputErrorBorderColor: 'Danger-6',
  inputErrorBackgroundColor: 'Neutral-fill-1',
  inputErrorHoverBorderColor: 'Danger-5',
  inputErrorHoverBackgroundColor: 'Neutral-fill-1',
  inputErrorFocusBorderColor: 'Danger-7',
  inputErrorFocusBackgroundColor: 'Neutral-fill-1',
  inputErrorFocusShadow: 'Danger-1',
  inputGroupFontColor: 'Neutral-text-5',
  inputGroupFontBackgroundColor: 'Neutral-fill-2',
  inputInfoFontColor: 'Brand-6',
  inputInfoBackgroundColor: 'Neutral-fill-1',
  inputInfoBorderColor: 'Neutral-border-2',
  inputInfoErrorFontColor: 'Danger-6',
  inputInfoErrorBackgroundColor: 'Danger-1',
  inputInfoErrorBorderColor: 'Danger-6',
  inputInnerPaddingX: 'Spacing-8',
  inputInnerPaddingY: 'Spacing-1',
  inputInnerFontSize: 'Font-14',
  inputInnerFontColor: 'Neutral-text-4',
  inputInnerPlaceFontColor: 'Neutral-text-4',
  inputInnerSmallPaddingX: 'Spacing-8',
  inputInnerSmallPaddingY: 'Spacing-1',
  inputInnerSmallFontSize: 'Font-12',
  inputInnerLargePaddingX: 'Spacing-12',
  inputInnerLargePaddingY: 'Spacing-3',
  inputInnerLargeFontSize: 'Font-16',
  inputInnerTopFontSize: 'Font-12',
  inputInnerTopSmallFontSize: 'Font-12',
  inputInnerTopLargeFontSize: 'Font-14',
};

export default inputTokens;
